
nosco.welcome.start();